// src/pages/Chat/KebabMenu.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { deleteChat } from '../../services/chatApi'; 

const KebabMenu = ({ chatId, onDelete, onCopy }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleDeleteClick  = async () => {
        try {
            await deleteChat(chatId);
            console.log(`Successfully deleted chat ${chatId} from backend`);
            onDelete(chatId);
            setIsOpen(false);
            } catch (error) {
                console.error('Failed to delete chat:', error);
                // Optionally, show an error message to the user
                // e.g., setError('Failed to delete chat. Please try again.');
            }
    };

    const handleCopyClick = () => {
        onCopy(chatId);
        setIsOpen(false);
    };

    return (
        <div className="relative" ref={menuRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-1 rounded-full hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-500"
            >
                <FiMoreVertical size={20} />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-32 bg-slate-900 border border-slate-700 rounded-md shadow-lg z-10">
                    <ul className="py-1">
                        <li>
                            <button
                                onClick={handleCopyClick}
                                className="w-full text-left px-4 py-2 text-sm text-gray-200 hover:bg-slate-700"
                            >
                                {t('chat.menu.copy')}
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={handleDeleteClick}
                                className="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-slate-700"
                            >
                                {t('chat.menu.delete')}
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default KebabMenu;